function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('comboButton', [function () {
    return {
      template: "\n                <div class=\"btn-group\" uib-dropdown dropdown-append-to-body>\n                    <button type=\"button\"\n                            ng-class=\"classes\"\n                            ng-click=\"ngClick(selectedOption)\">\n                            <ng-transclude></ng-transclude>\n                            {{ selectedOption }}\n                    </button>\n                    <button type=\"button\" ng-class=\"classes\" uib-dropdown-toggle>\n                        <span class=\"caret\"></span>\n                    </button>\n                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                        <li ng-repeat=\"o in options\"\n                            ng-click=\"selectOption($index)\"\n                            role=\"menuitem\"\n                            ng-class=\"{ active : selectedOption === o }\">\n                            <a>{{ o }}</a>\n                        </li>\n                    </ul>\n                </div>\n            ",
      transclude: true,
      scope: {
        ngClick: '<',
        options: '<',
        onOptionSelect: '<'
      },
      link: function link(scope, elem, attrs) {
        scope.classes = ['btn'];

        // If no classes supplied, use this as default
        if (!attrs.class) {
          scope.classes.push('btn-brand-alt');
        } else {
          var _scope$classes;
          (_scope$classes = scope.classes).push.apply(_scope$classes, _toConsumableArray(attrs.class.split(' ')));
        }
        scope.selectOption = function (index) {
          scope.selectedOption = scope.options[index];
          if (typeof scope.onOptionSelect === 'function') {
            scope.onOptionSelect(scope.selectedOption);
          }
        };

        // Reset the default selected option when the list of options change
        scope.$watch('options', function () {
          if (scope.options && scope.options.length) {
            scope.selectedOption = scope.options[0];
          }
        });

        // Put all class changes before this line
        scope.classes = scope.classes.join(' ');
      }
    };
  }]);
})();
